<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="solution">
        <div class="breadCrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/newsCenter' }">新闻中心</el-breadcrumb-item>
            <el-breadcrumb-item>公司新闻</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content">
          <div class="title">
            <p>喜讯 | 中标喜讯</p>
            <span>2021.04.08</span>
          </div>
          <div class="detail">
            <p>热烈祝贺我司凭借丰富的实施经验、过硬的技术实力和良好的企业信誉，于2021年4月8日顺利中标——中国光大银行信用卡科技敏捷体系建设实施服务采购项目（招标编号：TC210902A）。
              </p>
            <div class="picImg_Content">
              <div class="picImg"><img src="../../../public/newsImg/goodNews.png" alt=""></div> 
            </div>
            
            <p style="padding-top:20px">成绩是前进途中的里程碑，今日的成功是昨日的汗水灌溉所结出的硕果，相信未来会更好。</p>
            
          </div>
        </div>
        <div class="footNav">
          <ul>
            <li>上一篇：“暂无”</li>
            <li><a href="#/newsCenter/activity">下一篇：活动丨功存智能携手老麦咖啡亮相2020敏捷之旅上海站</a></li>
          </ul>
        </div>
      </div>    
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';

export default {
  components: { navmenu,footerMenu },

  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'新闻中心',
          detail:'News Center',
          src: require("../../../public/newsImg/newsbanner.png"),
        },
      ]
    }
  },
  mounted(){
    console.log(this.$route)
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/style/public.scss';

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      left: 231px;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:321px;opacity: 0;}
        to {left:231px;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:261px;opacity: 0;}
        to {left:231px;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      left: 231px;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
    }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
}

  .view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 90px;
    text-align: left;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: none;
        margin-left: 5px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          padding-bottom: 20px;
          // width: 326px;
        }
      }
    }
  }


.solution{
  height:1108px;
  .breadCrumb{
    height: 67px;
    border-bottom: 1px solid #ccc;
  }
  .content{
    height: 850px;
    p{
      font-size: 16px;
      line-height: 32px;
    }
    .title{
      height: 33px;
      padding-top: 60px;
      p{
        font-size: 26px;
        font-weight: bold;
      }
      
    }
    .detail{
      text-align: left;
      padding-top: 64px;
      .picImg_Content{
        display: flex;
        justify-content: space-around;
        width: 1200px;
        margin-top:40px;
        .picImg{
          img{
            width: 800px;
          }
        }
      }
      
    }
  }
  .footNav{
    ul{
      height: 128px;
      line-height: 128px;
      font-size: 16px;
      color: #fff;
      display: flex;
      justify-content: space-around;
    }
    li:hover{
      cursor: pointer;
      height: 148px;
    }
    li{
      a{
        color: #fff;
      }
      width: 50%;
      height: 100%;      
    }
    li:first-child{
      background: url("../../../public/newsImg/libg_1.png");
    }
    li:last-child{
      background: url("../../../public/newsImg/libg_2.png");
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/newsCenter/goodNews.vue